import $ from "jquery";

export default function () {
  var $tooltips = $('[data-toggle="tooltip"]');

  $tooltips
    .tooltip({
      html: true
    });
  $tooltips.click(function () {
    $(this).tooltip('toggle');
  });

  $(document).on('click', '.tooltip .close-link', function (e) {
    e.preventDefault();
    $(e.target).closest('.tooltip').tooltip('hide');
  });
};
